"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alchemyApiKeys = void 0;
exports.alchemyApiKeys = {
    mainnetApp: '-UZKxrTJIlpJadJ2s9Pstn295BHI5BGo',
    testnetApp: '-FFD4iQIllF0Ku75XYAGlGYcclwHwv4b',
    devApp: 'KZAmDMiCUR475t_CW_0g1c0RsGjAJ1ob',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxjaGVteS1hcGkta2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zY2hlbWEvYWxjaGVteS1hcGkta2V5cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGNBQWMsR0FBRztJQUM1QixVQUFVLEVBQUUsa0NBQWtDO0lBQzlDLFVBQVUsRUFBRSxrQ0FBa0M7SUFDOUMsTUFBTSxFQUFFLGtDQUFrQztDQUNsQyxDQUFBIn0=